import React, { Fragment } from 'react';
import { Typography } from '@material-ui/core';
import ConfirmDialog from './ConfirmDialog';

const boldSentence = (items) => items.map((item, index) => (
    <Fragment key={item}>
        {index > 0 && (index === items.length - 1 ? ' and ' : ', ')}
        <strong>{item}</strong>
    </Fragment>
));

const LinkedinSyncConfirmDialog = ({ open, currentContactLabel, otherContactLabels, onConfirm, onCancel, onClose }) => (
    <ConfirmDialog
        open={open}
        title="This contact exists in another area of the database."
        onConfirm={onConfirm}
        onCancel={onCancel}
        onClose={onClose}
        showCloseIcon
        confirmText="Yes"
        cancelText="No"
    >
        <Typography>
            Match detected between <strong>{currentContactLabel}</strong> and {boldSentence(otherContactLabels || [])}.
            Would you like to update the LinkedIn URL on their other profile(s) as well?
        </Typography>
    </ConfirmDialog>
);

export default LinkedinSyncConfirmDialog;